import styled, { css } from "styled-components";
import { border, boxShadow, color, onHover, units } from "@m/alchemy-theme";
import { CardSection } from "./CardSection.styled";
export const Card = styled.div `
  position: relative;
  display: inline-flex;
  flex-direction: column;
  color: ${color("typeBody")};
  background-color: ${color("container")};
  border-radius: ${units(2.25)};
  width: ${({ width }) => (typeof width === "string" ? width : typeof width === "number" ? `${width}px` : "auto")};
  max-width: ${({ width }) => (typeof width === "string" && width !== "auto" ? width : "none")};
  height: ${({ height }) => typeof height === "string" ? height : typeof height === "number" ? `${height}px` : "auto"};
  max-height: ${({ height }) => (typeof height === "string" && height !== "auto" ? height : "none")};

  ${({ hasOverflow }) => !hasOverflow &&
    css `
      overflow: hidden;
    `};

  ${({ hasBorder }) => hasBorder &&
    css `
      border: ${border()};
    `};

  ${({ shadowDepth }) => shadowDepth !== "none" &&
    css `
      box-shadow: ${boxShadow(shadowDepth)};
    `};

  ${({ hasHoverEffect }) => hasHoverEffect &&
    css `
      transition: all 0.2s ease-in;

      ${onHover(css `
        box-shadow: ${boxShadow("cardHover")};
        transform: translateY(-3px);
      `)}
    `};

  ${CardSection}:not(:last-child) {
    border-bottom: ${border()};
  }
`;
